import { useDispatch } from 'react-redux';

import { clearTechnicians } from './technician.slice';
import { clearTypes } from './types.slice';
import { clearCategories } from './categories.slice';
import { clearStore } from './projectStores.slice';
import { clearDistricts } from './districts.slice';
import { clearUserTypes } from './userTypes.slice';
import { clearWorkrooms } from './workrooms.slice';
import { clearInstallerWorkType } from './installerWorkType.slice';
import { clearSourceStatusType } from './sourceStatusType.slice';
import { clearProjectStatusType } from './projectStatusType.slice';
import { clearQuoteStatusType } from './quoteStatusType.slice';
import { clearTechnicianLimitList } from './technicianLimit.slice';
import { clearDefaultColors } from './defaultColorCode.slice';

const clearMasterDataHook = () => {
  const dispatch = useDispatch();

  const clearMasterData = () => {
    dispatch(clearTechnicians());
    dispatch(clearTypes());
    dispatch(clearCategories());
    dispatch(clearStore());
    dispatch(clearDistricts());
    dispatch(clearUserTypes());
    dispatch(clearWorkrooms());
    dispatch(clearInstallerWorkType());
    dispatch(clearSourceStatusType());
    dispatch(clearProjectStatusType());
    dispatch(clearQuoteStatusType());
    dispatch(clearTechnicianLimitList());
    dispatch(clearDefaultColors());
  };

  return clearMasterData;
};

export default clearMasterDataHook;
